import { emit, events } from 'elc-service-bus';

export class BroadcastProductsLoadedUseCase {
    private productIds: string[] = [];

    constructor(productIds: string[]) {
        this.productIds = productIds;
    }

    public execute = async () => {
        if (this.productIds.length > 0) {
            emit(events.PRODUCT_LOADED, this.productIds);
        }
    };
}
